import { styled } from '@automata/mui-theme';
import { ReactNode, useMemo } from 'react';
import { useResizeDetector } from 'react-resize-detector';

import { SvgContext, svgContext } from './Context';

const OuterElement = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const SvgElement = styled('svg')`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const PaddingContainer = styled('g')``;

export interface Props {
  children: ReactNode;
  padding?: number;
}

const SvgComponent = ({ children, padding = 0 }: Props): JSX.Element => {
  const { width = 0, height = 0, ref } = useResizeDetector<HTMLDivElement>();

  const innerWidth = Math.max(width - padding * 2, 0);
  const innerHeight = Math.max(height - padding * 2, 0);

  const contextValue: SvgContext = useMemo(
    () => ({
      width: innerWidth,
      height: innerHeight,
    }),
    [innerHeight, innerWidth]
  );

  return (
    <svgContext.Provider value={contextValue}>
      <OuterElement ref={ref}>
        <SvgElement>
          <PaddingContainer transform={`translate(${padding} ${padding})`}>
            {children}
          </PaddingContainer>
        </SvgElement>
      </OuterElement>
    </svgContext.Provider>
  );
};

export default SvgComponent;
